/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum PaymentAccountStatus {
	Active = 'Active',
	Inactive = 'Inactive',
	Warning = 'Warning',
	UnavailableFeature = 'UnavailableFeature',
	Onboarding = 'Onboarding',
	PendingVerification = 'PendingVerification',
	Removed = 'Removed',
}
